import Color from "color";

export function createEl(tag, innerHTML, options = {}) {
    if (!tag) return;
    const el = document.createElement(tag);

    if (options.className) {
        el.className = options.className;
    }

    if (options.id) {
        el.id = options.id;
    }

    if (innerHTML) {
        el.innerHTML = innerHTML;
    }
    return el;
}

export function checkParent(parent, child) {
    return parent.contains(child);
}

export function hexToRGB(hex) {
    if (hex.length > 7) {
        throw "Only six-digit hex colors are allowed.";
    }

    if (hex.length === 7) {
        hex = hex.slice(1);
    }

    var aRgbHex = hex.match(/.{1,2}/g);
    var aRgb = [parseInt(aRgbHex[0], 16), parseInt(aRgbHex[1], 16), parseInt(aRgbHex[2], 16)];
    return aRgb;
}

export function RGBToHex(rgbVal, useHash = false) {
    let a = rgbVal.split("(")[1].split(")")[0];
    a = a.split(",");

    let b = a.map(function(x) {
        x = parseInt(x).toString(16);
        return x.length == 1 ? "0" + x : x;
    });

    const prefix = useHash ? "#" : "0x";

    return prefix + b.join("");
}

export function preloadImages(imageUrls, callback) {
    let imagesLoaded = 0;
    const preloadImages = [];

    imageUrls.forEach(imageUrl => {
        const image = new Image();
        image.src = imageUrl;
        preloadImages.push(image);
    });

    // check images have loaded
    for (var i = 0; i < preloadImages.length; i++) {
        preloadImages[i].onload = function() {
            imagesLoaded++;
            if (imagesLoaded == preloadImages.length) {
                if (typeof callback == "function") {
                    callback();
                }
            }
        };
    }
}

export function colorToHex(color, useHash = false) {
    // already hex
    if (color.charAt(0) == "0" && color.charAt(1) == "x") {
        return useHash ? color.replace("#", "0x") : color;
    }
    // hash val
    else if (color.charAt(0) == "#") {
        return useHash ? color : color.replace("#", "0x");
    }
    // rgb or unknown
    else {
        const firstThreeChars = color.match(/.{1,3}/g)[0];
        if (firstThreeChars === "rgb") {
            return useHash ? RGBToHex(color, true) : RGBToHex(color);
        } else {
            return null;
        }
    }
}

export function ColorRGBToHexadecimalInt(rgbVal, options = {}) {
    let c = RGBToHex(rgbVal);
    let cMod;
    let cModRgb;

    if (options.darken) {
        cMod = Color(rgbVal)
            .darken(options.darken)
            .rgb()
            .array();
        cModRgb = `rgb(${cMod[0].toFixed(0)},${cMod[1].toFixed(0)},${cMod[2].toFixed(0)})`;
        c = RGBToHex(cModRgb);
    }

    return parseInt(c, 16);
}
